import React, { useCallback, useEffect, useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [modalContent, setModalContent] = useState<'privacy' | 'terms' | null>(null);
  const closeModal = useCallback(() => setModalContent(null), []);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && modalContent) closeModal();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [modalContent, closeModal]);
  return <>
      <footer className="py-16 border-t border-white/5 text-center px-5 bg-dark" role="contentinfo" data-id="element-174">
        <div className="flex items-center justify-center gap-6 text-sm mb-6" data-id="element-175">
          <button onClick={() => setModalContent('privacy')} className="bg-transparent border-none text-white/50 underline cursor-pointer text-[11px] uppercase transition-colors hover:text-gold" data-id="element-176">
            Privacy Policy
          </button>
          <span className="text-white/20" aria-hidden="true" data-id="element-177">
            |
          </span>
          <button onClick={() => setModalContent('terms')} className="bg-transparent border-none text-white/50 underline cursor-pointer text-[11px] uppercase transition-colors hover:text-gold" data-id="element-178">
            Terms of Service
          </button>
        </div>
        <p className="text-[10px] text-white/40 mt-8 tracking-[1px] leading-relaxed max-w-2xl mx-auto uppercase" data-id="element-179">
          © 2026 EL CÓDIGO 888. ESTE SITIO NO ES PARTE DE FACEBOOK O META INC.{' '}
          <br data-id="element-180" />
          DERECHOS RESERVADOS. REPROGRAMACIÓN TOTAL DE LIQUIDEZ.
        </p>
      </footer>

      {modalContent && <LegalModal content={modalContent} onClose={closeModal} data-id="element-181" />}
    </>;
}